export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});
export const formatUSD = (value) => {
    if (isNaN(value)) {
        return "$0";
    }
    let formatted = USDollar.format(value);
    return formatted;
}

export const calculateTotalUpcharge = (options) => {
    return options.reduce((acc, option) => {
            const optionUpcharge = option.items.reduce((innerAcc, item) => innerAcc + (item.upCharge ? item.upCharge : 0), 0);
            return acc + optionUpcharge;
    }, 0);
};

export const calculateDiscountedPrice = (price) => {
    return price - (productDiscount > 0 ? price * (productDiscount / 100) : 0);
};
//session item is being used for option items with not discount property
const productDiscount = sessionStorage.getItem('productDiscount');



export const calculateDiscountedPriceForCart = (price, discount) => {
    return price - (discount > 0 ? price * (discount / 100) : 0);
};

export const calculateFinalUnitPrice = (productItem) => {
    if (productItem == null || productItem.details == null || productItem.details == undefined) {return 0 }

    const basePrice = productItem.details.price;
    const discount = productItem.details.discount || 0;
    const totalUpcharge = productItem.options && productItem.options.length > 0 ? calculateTotalUpcharge(productItem.options) : 0;
    const totalAmount = basePrice + totalUpcharge;
    return calculateDiscountedPriceForCart(totalAmount, discount);
};

export const formatProductCode = (product) => {
    const options = product.options;
    const details = product.details;
    let productCode = details.freedomCode;

    if (options && options.length > 0) {
        options.map((option) => {
            if (option.items && option.items.length > 0) {
                option.items.map((item) => {
                    if (option.type === 2) {
                        productCode += '.' + (item?.color?.colorCode ? item?.color?.colorCode : item?.color?.name);
                    } else { 
                        if (item?.code) {
                            productCode += '.' + item?.code;
                        } else if (item?.title) {
                            productCode += '.' + item?.title;
                        }
                    }
                });
            }
        });
    }

    return productCode;  
}

export const formatPhoneNumber = (phone) => {
    var cleaned = phone.replace('+', '');
    var match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '+ ' + match[1] + ' (' + match[2] + ') ' + match[3] + '-' + match[4];
    }
    match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    }
    match = cleaned.match(/^(\d{3})(\d{4})$/);
    if (match) {
        return match[1] + '-' + match[2];
    }
    return phone;
}

